<template>
                                <div class="tab-pane fade" id="part2" role="tabpanel" aria-labelledby="profile-tab">
                                <div style="overflow-x: auto;">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th rowspan="2" class="text-center">
                                                    Номи нишондиҳандаҳо
                                                </th>
                                                <th colspan="2" class="text-center">
                                                   Хамагӣ
                                                </th>
                                                <th colspan="2" class="text-center">
                                                   аз он обӣ
                                                </th>
                                            </tr>
                                            <tr>
                                                <th width="10%" class="text-center">
                                                   Масоҳат (сотих)
                                                </th>
                                                <th width="10%" class="text-center">
                                                   ҷамъоварии ҳосил (сентнер)
                                                </th>
                                                <th width="10%" class="text-center">
                                                   Масоҳат (сотих)
                                                </th>
                                                <th width="10%" class="text-center">
                                                   ҷамъоварии ҳосил (сентнер)
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            
                                                <tr v-for="d in this.class2.filter(x=>x.Part==1)" :key="d">

                                                    <td>
                                                        {{d.Name }}
                                                    </td>
                                                    <td>
                                                        <InputNumber v-if="d.Readonly != 2" inputClass="form-control bclass"  v-model="d.c01"                                                                
                                                                            :minFractionDigits="0"
                                                                            :maxFractionDigits="2"
                                                                            @update:modelValue="markModified(d)"
                                                                            />  
                                                    </td>
                                                    <td>
                                                        <InputNumber v-if="d.Readonly != 2" inputClass="form-control bclass"  v-model="d.c02"                                                                
                                                                            :minFractionDigits="0"
                                                                            :maxFractionDigits="2"
                                                                            @update:modelValue="markModified(d)"
                                                                            />  
                                                    </td>
                                                    <td>
                                                        <InputNumber v-if="d.Readonly != 2" inputClass="form-control bclass"  v-model="d.c03"                                                                
                                                                            :minFractionDigits="0"
                                                                            :maxFractionDigits="2"
                                                                            @update:modelValue="markModified(d)"
                                                                            />  
                                                    </td>
                                                    <td>
                                                        <InputNumber v-if="d.Readonly != 2" inputClass="form-control bclass"  v-model="d.c04"                                                                
                                                                            :minFractionDigits="0"
                                                                            :maxFractionDigits="2"
                                                                            @update:modelValue="markModified(d)"
                                                                            />  
                                                    </td>
                                                </tr>
                                           
                                        </tbody>
                                    </table>

                                </div>
                            </div>

                            <div class="tab-pane fade" id="part3" role="tabpanel" aria-labelledby="profile-tab">
                                <div style="overflow-x: auto;">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th class="text-center">
                                                    Номи нишондиҳандаҳо
                                                </th>
                                                <th class="text-center">
                                                    Рамзи сатр
                                                </th>
                                                <th class="text-center">
                                                   Ҳамагӣ (сар)
                                                </th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                           
                                                <tr v-for="d in this.class2.filter(x=>x.Part==2)" :key="d">

                                                    <td>
                                                        {{d.Name }}
                                                    </td>
                                                    <td  class="text-center">
                                                        {{d.Kod }}
                                                    </td>
                                             <td class="text-center">
                                                        <InputNumber v-if="d.Readonly != 2" inputClass="form-control bclass"  v-model="d.c01"                                                                
                                                                            :minFractionDigits="0"
                                                                            :maxFractionDigits="2"
                                                                            @update:modelValue="markModified(d)"
                                                                            />  
                                                    </td>
                       

                                                </tr>
                                             
                                        </tbody>
                                    </table>

                                </div>
                            </div>

                            <div class="tab-pane fade" id="part4" role="tabpanel" aria-labelledby="profile-tab">
                                <div style="overflow-x: auto;">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th class="text-center">
                                                    Номи нишондиҳандаҳо
                                                </th>
                                                <th class="text-center">
                                                    Рамзи сатр
                                                </th>
                                                <th class="text-center">
                                                   Шумора, адад
                                                </th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            <tr v-for="d in this.class2.filter(x=>x.Part==3)" :key="d">

                                                    <td>
                                                        {{d.Name}}
                                                    </td>
                                                    <td  class="text-center">
                                                        {{d.Kod}}
                                                    </td>
                                             <td class="text-center">
                                                        <InputNumber v-if="d.Readonly != 2" inputClass="form-control bclass"  v-model="d.c01"                                                                
                                                                            :minFractionDigits="0"
                                                                            :maxFractionDigits="2"
                                                                            @update:modelValue="markModified(d)"
                                                                            />  
                                                    </td>
 

                                                </tr>
                                            
                                        </tbody>
                                    </table>

                                </div>
                            </div>

                            <div class="tab-pane fade" id="part5" role="tabpanel" aria-labelledby="profile-tab">
                                <div style="overflow-x: auto;">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th class="text-center">
                                                    Номи нишондиҳандаҳо
                                                </th>

                                                <th class="text-center">
                                                  Замин (сотих)
                                                </th>
                                                <th class="text-center">
                                                  Ҳосил (сентнер)
                                                </th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            <tr v-for="d in this.class2.filter(x=>x.Part==4)" :key="d">

                                                    <td>
                                                        {{d.Name}}
                                                    </td>

                                                     <td  class="text-center">
                                                        <InputNumber v-if="d.Readonly != 2" inputClass="form-control bclass"  v-model="d.c01"                                                                
                                                                            :minFractionDigits="0"
                                                                            :maxFractionDigits="2"
                                                                            @update:modelValue="markModified(d)"
                                                                            />  
                                                    </td>
                                                    <td class="text-center">
                                                            <InputNumber v-if="d.Readonly != 2" inputClass="form-control bclass"  v-model="d.c02"                                                                
                                                                            :minFractionDigits="0"
                                                                            :maxFractionDigits="2"
                                                                            @update:modelValue="markModified(d)"
                                                                            />  
                                                    </td>
 

                                                </tr>
                                             
                                        </tbody>
                                    </table>

                                </div>
                            </div>

                            <div class="tab-pane fade" id="part6" role="tabpanel" aria-labelledby="profile-tab">
                                <div style="overflow-x: auto;">
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th class="text-center">
                                                   Номи нишондиҳандаҳо
                                                </th>
                                         
                                                <th class="text-center">
                                                    
                                                </th>
                                            </tr>

                                        </thead>
                                        <tbody>
                                            <tr v-for="d in this.class2.filter(x=>x.Part==5)" :key="d">

                                                    <td>
                                                        {{d.Name}}
                                                    </td>
                                              
                                           <td>
                                                        <InputNumber v-if="d.Readonly != 2" inputClass="form-control bclass"  v-model="d.c01"                                                                
                                                                            :minFractionDigits="0"
                                                                            :maxFractionDigits="2"
                                                                            @update:modelValue="markModified(d)"
                                                                            />  
                                                      
                                                    </td>

                                                </tr>
                                             
                                        </tbody>
                                    </table>

                                </div>
                            </div>
</template>>



<script>
 


export default {
  name: "Parts",
props: ["class2"],


  data() {
    return {


    };
  },
  methods: {

    markModified(row) {
  //  if (row._state || row._state !=1) {
        row._state = 1
       // console.log(row);
       
  //  }
}

}
}



</script>

<style scoped> 



::v-global(.bclass){
  border-color:rgb(147, 168, 185)  ;
 
 }

 
::v-global(.bclass:focus){
  border-color:rgb(147, 168, 185)  ;
box-shadow: 1px 1px 10px rgb(0, 132, 255);;
 }
</style>
